/** Firebase Auth, loaded lazily and only when configured (VITE_FIREBASE_*). */
const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
}

export const firebaseConfig = config

export const firebaseEnabled = Boolean(config.apiKey)

let authPromise = null

export function getFirebaseAuth() {
  if (!firebaseEnabled) return Promise.resolve(null)
  authPromise ??= Promise.all([import('firebase/app'), import('firebase/auth')]).then(
    ([{ initializeApp }, authModule]) => {
      const app = initializeApp(config)
      return { app, auth: authModule.getAuth(app), m: authModule }
    },
  )
  return authPromise
}
